import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SummaryByTerritoryReportRoutingModule } from './summary-by-territory-report-routing.module';
import { SummaryByTerritoryReportComponent } from './summary-by-territory-report.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { SbtrFilterComponent } from './sbtr-filter/sbtr-filter.component';
import { ReportModule } from '../report.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    SummaryByTerritoryReportRoutingModule,
    ReportModule
  ],
  declarations: [SummaryByTerritoryReportComponent, SbtrFilterComponent],
  entryComponents:[SbtrFilterComponent]
})
export class SummaryByTerritoryReportModule { }
